import { useEffect, useState } from 'react';

export const useThemeEditor = (initialThemes) => {
	const [pluginEnabled, setPluginEnabled] = useState(false);
	const [themes, setThemes] = useState(initialThemes);

	useEffect(() => {
		const onUpdateTheme = (ev) => {
			console.debug('onUpdateTheme ', ev.detail);
			setPluginEnabled(true);
			setThemes(ev.detail);
		};

		document.addEventListener('themePlugin.updateTheme', onUpdateTheme);
		document.dispatchEvent(new CustomEvent('themePlugin.appReady', { detail: initialThemes }));

		return () => { document.removeEventListener('themePlugin.updateTheme', onUpdateTheme); };
	}, [initialThemes]);

	return pluginEnabled ? themes : initialThemes;
};
